import { API } from '../helpers/fetcher'
import { prepareMetadata } from '../hooks/useMetadata'
import { DataDog } from '../datadog'

export const validateMerchant = async validationUrl =>
  API.post('v1/transaction/authorise/apple-pay-merchant', { validationUrl })

export const authorizePayment = async (transactionDetails, payment) => {
  if (transactionDetails.metadata === 'invalid') {
    DataDog.error(`Wrong format of metadata`)
    console.error(`Wrong format of metadata`)
  } else if (transactionDetails.metadata === 'lengthError') {
    console.error('Metadata should be not greater than 100 characters')
  }

  const body = {
    ...transactionDetails,
    amount: transactionDetails.overrideAmount || transactionDetails.amount,
    paymentUrl: window.location.href,
    metadata: prepareMetadata(transactionDetails.metadata),
    applePay: payment
  }
  return API.post('v1/transaction/apple-pay/authorise', body)
}
